// ============================================================
// PROJETOS EDALIX — fallback local / referência da estrutura.
// A fonte de verdade é o banco de dados (editável pelo painel /admin).
// Este arquivo é usado apenas se a API estiver indisponível.
//
// Para PUBLICAR um projeto pelo painel: preencha "url" com a URL real.
// Com url real, "VER PROJETO" abre o site em nova aba. Com "#", o
// projeto não mostra link quebrado — use o painel para desativar
// projetos ainda em desenvolvimento.
// ============================================================

export const PROJECTS = [
  {
    slug: "pousada-luz-do-sol",
    nome: "Pousada Luz do Sol",
    categoria: "Site para hospedagem",
    descricao:
      "Site para pousada com apresentação de quartos e tarifas, localização, atrações da região e reserva direta pelo WhatsApp.",
    descricaoCompleta:
      "Site desenvolvido para a Pousada Luz do Sol, em Penha (SC), com apresentação dos quartos e tarifas, localização, atrações da região, avaliações e reserva direta pelo WhatsApp.",
    imagem: "/projects/pousada-luz-do-sol.webp",
    galeria: ["/projects/pousada-luz-do-sol.webp"],
    tecnologias: [],
    funcionalidades: [
      "Apresentação de quartos e tarifas",
      "Seções de localização e atrações da região",
      "Avaliações de hóspedes",
      "Reserva e contato direto pelo WhatsApp",
    ],
    objetivo:
      "Fortalecer a presença digital da pousada e transformar visitantes em reservas.",
    url: "https://funny-lily-000438.netlify.app",
    botao: "VER PROJETO",
    ativo: true,
    ordem: 1,
  },
  {
    slug: "chale-do-lago",
    nome: "Chalé do Lago",
    categoria: "Site para hospedagem",
    descricao:
      "Site para hospedagem com apresentação da experiência, acomodações, galeria de fotos, calendário e consulta de disponibilidade.",
    descricaoCompleta:
      "Site desenvolvido para o Chalé do Lago, em São Domingos (SC), com apresentação da experiência, acomodações, galeria de fotos, calendário e consulta de disponibilidade.",
    imagem: "/projects/chale-do-lago.webp",
    galeria: ["/projects/chale-do-lago.webp"],
    tecnologias: [],
    funcionalidades: [
      "Apresentação das acomodações e da experiência",
      "Galeria de fotos do refúgio",
      "Calendário e consulta de disponibilidade",
      "Localização e contato para reservas",
    ],
    objetivo:
      "Apresentar o refúgio com visual acolhedor e facilitar a consulta de disponibilidade e as reservas.",
    url: "https://guileless-pixie-adb12a.netlify.app",
    botao: "VER PROJETO",
    ativo: true,
    ordem: 2,
  },
  {
    slug: "irani-cloud",
    nome: "Irani Cloud",
    categoria: "Tecnologia / Provedor / Infraestrutura",
    descricao:
      "Site institucional para provedor de internet, com apresentação de planos, serviços, cobertura e contato direto.",
    descricaoCompleta:
      "Site desenvolvido para a Irani Cloud, provedor de internet de Irani e região, com apresentação de planos, serviços, área de cobertura e contato direto pelo WhatsApp.",
    imagem: "/projects/irani-cloud.webp",
    galeria: ["/projects/irani-cloud.webp"],
    tecnologias: [],
    funcionalidades: [
      "Apresentação de planos de internet",
      "Seções de serviços e área de cobertura",
      "Contato rápido pelo WhatsApp",
      "Layout escuro com a identidade do provedor",
    ],
    objetivo:
      "Apresentar os serviços do provedor com visual moderno e facilitar o contato de novos clientes.",
    url: "https://papaya-peony-450e1f.netlify.app",
    botao: "VER PROJETO",
    ativo: true,
    ordem: 3,
  },
  // Projetos futuros — permanecem no painel como INATIVOS (fora do portfólio público)
  {
    slug: "pizzaria",
    nome: "Pizzaria",
    categoria: "Site e cardápio digital",
    descricao:
      "Demonstração de site moderno para restaurante, com cardápio digital, produtos e experiência otimizada para pedidos.",
    descricaoCompleta:
      "Demonstração de site e cardápio digital para restaurantes desenvolvida pela EDALIX, com apresentação de produtos, categorias do cardápio, montagem de pedido e experiência otimizada para pedidos rápidos pelo celular.",
    imagem: "/projects/pizzaria.webp",
    galeria: ["/projects/pizzaria.webp"],
    tecnologias: [],
    funcionalidades: [
      "Cardápio digital organizado por categorias",
      "Apresentação de produtos com fotos e preços",
      "Montagem de pedido direto pelo celular",
      "Chamada para pedido rápido via WhatsApp",
    ],
    objetivo:
      "Mostrar como um restaurante pode digitalizar o cardápio e facilitar pedidos com uma experiência moderna.",
    url: "#",
    botao: "VER PROJETO",
    ativo: false,
    ordem: 4,
  },
  {
    slug: "sistema-gestao",
    nome: "Sistema de Gestão",
    categoria: "Sistema personalizado",
    descricao:
      "Sistema de gestão com dashboard, clientes, vendas, pedidos, financeiro, relatórios e indicadores.",
    descricaoCompleta:
      "Demonstração de sistema de gestão desenvolvida pela EDALIX, com dashboard, indicadores de vendas, clientes, pedidos, financeiro e relatórios em uma interface moderna, organizada e pensada para o dia a dia do negócio.",
    imagem: "/projects/sistema-de-gestao.webp",
    galeria: ["/projects/sistema-de-gestao.webp"],
    tecnologias: [],
    funcionalidades: [
      "Dashboard com indicadores de vendas",
      "Gestão de clientes, vendas e pedidos",
      "Módulos financeiro e de relatórios",
      "Interface personalizada para o negócio",
    ],
    objetivo:
      "Mostrar como uma empresa pode centralizar vendas, clientes e resultados em um único sistema sob medida.",
    url: "#",
    botao: "VER PROJETO",
    ativo: false,
    ordem: 5,
  },
];

export const getProject = (slug) => PROJECTS.find((p) => p.slug === slug && p.ativo !== false);
